/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAMoveIcon24Solid = forwardRef('UiCursorAMoveIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 3a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M7.447 3.386C6.03 2.321 4.007 3.33 4.005 5.102l-.016 13.733c-.002 2.066 2.627 2.946 3.869 1.294l3.284-4.369a.65.65 0 0 1 .52-.26l5.467.007c2.066.002 2.946-2.627 1.295-3.869L7.447 3.386Z" }),
        React.createElement("path", { d: "M17.5 6a1 1 0 1 0 0 2H21a1 1 0 1 0 0-2h-3.5Z" })));
});
